/**
 * Display-only card-number masking.
 *
 * Rules:
 *   - Petro-Pass (Phase FC-B.1R, Feb 2026): last 4 characters ONLY.
 *       Prefer the stored `last4` field when the caller can supply it;
 *       otherwise safely derive the final 4 characters of the full
 *       card number. Never displays last-5 for Petro-Pass.
 *   - Esso / legacy long cards (May 2026 — matches
 *       `backend/routes/transactions._mask_card_for_display`):
 *       cards longer than 6 chars → last 5 digits.
 *   - Short cards (Pipeline 4-digit): return as-is.
 *
 * Internal API payloads still carry the full `card_number`; this helper is
 * ONLY for the table cells / PDF body cells the operator + customer see.
 *
 * Signature is backward-compatible: callers that don't supply `network`
 * fall back to the pre-FC-B.1R rules exactly.
 */
export function formatCard(cardNumber, network, last4) {
  const cn = (cardNumber == null ? "" : String(cardNumber)).trim();
  const net = (network == null ? "" : String(network)).trim().toLowerCase();

  if (net === "petro_pass") {
    // Prefer the backend-derived last4; fall back to the final 4 chars
    // of whatever card number we were handed. Empty/null → "".
    const stored = last4 == null ? "" : String(last4).trim();
    if (stored) return stored;
    return cn.slice(-4);
  }

  // Legacy behaviour preserved verbatim for Esso, Pipeline, ta_petro and
  // any un-networked caller.
  if (cn.length > 6) return cn.slice(-5);
  return cn;
}

export default formatCard;
